import { Link } from 'react-router-dom';

import styled, { createGlobalStyle } from '../../../../consts/styled';
import { VStack } from '@chakra-ui/react';
import {
  colors,
  media,
  SECONDARY_FONT_FAMILY,
  spacing,
} from '../../../../App/ChakraTheme';
import { LessonName as LessonNameUnstyled } from '../../../../components/LessonName';

import NavigationSecondRow from '../../components/NavigationSecondRow';

export const OverrideBackground = createGlobalStyle`
  body {
    background-image: none !important;
  }
`;

export const BackButton = styled(Link)`
  position: absolute;
  transform: translateY(-50%);
  left: ${spacing.BASE_PLUS};
  top: 50%;
  display: flex;
  align-items: center;
  color: ${colors.darkblue};

  svg {
    margin-right: ${spacing.TINY};
    transition: transform 400ms;
    transform: translateX(0);
  }

  &:hover {
    svg {
      transform: translateX(-10px);
    }
  }
`;

export const LessonName = styled(LessonNameUnstyled)`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-top: ${spacing.TINY};
  margin-bottom: ${spacing.TINY};
  align-items: flex-start !important;
  // display: block;

  & > .chakra-text.body-x-small {
    fontFamily: ${SECONDARY_FONT_FAMILY},
    fontWeight: normal,
    fontStyle: normal,
    fontStretch: normal,
    letterSpacing: 0.2px,
    fontSize: 15px,
    lineHeight: 1.6,
    color: ${(props) => (props.disabled ? colors.slategray : 'initial')};
    font-weight: ${(props) => (props.highlight || props.active ? 700 : 400)};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
    transition: all 400ms;
    margin-left: 30px;
  }

  & > div.circle {
    width: 14px;
    height: 14px;
    margin-top: 6px;
    flex-shrink: 0;
    background-color: ${(props) =>
      props.isDone ? colors.limegreen : colors.white};
    border-color: ${(props) =>
      props.active
        ? colors.darkblue
        : colors.applyOpacity(colors.mischka, 0.8)};
  }
`;

export const LeftColumn = styled(VStack)<{ opened: boolean }>`
  padding-top: ${spacing.BASE_PLUS};
  width: 310px !important;
  flex-basis: 310px !important;
  flex-shrink: 0;
  flex-grow: 0;
  transition: all 400ms, width 400ms;
  overflow-x: hidden;
  scroll-behavior: smooth;
  position: relative;
  margin-left: ${({ opened }) => (opened ? '0%' : '-330px')} !important;
  opacity: ${({ opened }) => (opened ? '1' : '0')} !important;
  ${media.tablet`
    width: 320px !important;
    flex-basis: 320px !important;
    margin-left: ${({ opened }: { opened: boolean }) =>
      opened ? '0' : '-320px'} !important;
  `};

  .content-title-container a {
    width: 100%;
  }
`;

export const RightColumn = styled(VStack)`
  width: auto;
  min-width: calc(100% - 120px);
  flex: 0 1 70% !important;
  min-width: auto;
  flex-grow: 1 !important;
  ${media.tablet`
    margin-top:30px;
  `};
  ${media.phone`
    min-width: 100%;
  `};
`;

export const ToggleSideBar = styled.div<{ opened: boolean }>`
  cursor: pointer;
  display: inline-block;
  text-align: right;
  position: absolute;
  padding-right: 10px;
  top: 0;
  transition: left 400ms;
  background-color: ${colors.white};
  left: ${({ opened }) => (opened ? '298px' : '16px')};
  z-index: 5;
`;

export const UnitTitle = styled(NavigationSecondRow)`
  padding-left: 170px;
  ${media.tablet`
    padding-left: 60px;
  `}
`;
